export * from './SymbolsCounter';
